import { List, Datagrid, TextField, NumberField, DateField, useRecordContext } from 'react-admin';
import { Chip } from '@mui/material';

const TypeChip = () => {
    const record = useRecordContext();
    if (!record || !record.type) return null;
    const isPercent = record.type === 'Percent';
    return <Chip label={isPercent ? '%' : '₽'} size="small" sx={{
        bgcolor: isPercent ? '#E3F2FD' : '#FFF3E0',
        color: isPercent ? '#1565C0' : '#E65100',
        fontWeight: 700,
    }} />;
};

const DiscountList = () => (
    <List perPage={25} sort={{ field: 'id', order: 'ASC' }}>
        <Datagrid rowClick="edit">
            <TextField source="name" label="Название" />
            <TypeChip source="type" label="Тип" sortable={false} />
            <NumberField source="value" label="Значение" />
            <DateField source="startDate" label="Начало" />
            <DateField source="endDate" label="Конец" />
        </Datagrid>
    </List>
);

export default DiscountList;
